// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false


import {Carousel, CarouselItem, Slider} from 'element-ui';

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Slider)

// 注册全局指令
import directives from "./libs/directives"

Object.keys(directives).forEach(key => Vue.directive(key, directives[key]))

// 注册全局组件
import "./libs/global_components.js"


// 引入语音聊天室ui
import './views/speakerChatroom/js/element'
// 样式穿透
import './style/common.less'
// // 引入ajax实例, 并挂载在Vue.prototype上
// import ajaxRequest from '@/api/ajax'
// Vue.prototype.$ajaxRequest = ajaxRequest

// 移动端组件引入
import {
  Tabbar,
  TabbarItem,
  Cell,
  CellGroup,
  NavBar,
  Popup,
  Overlay,
  Lazyload,
  ImagePreview,
  Icon,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Button,
  Rate,
  Field,
  Dialog
} from 'vant';
import 'vant/lib/index.css';

Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(NavBar);
Vue.use(Popup)
Vue.use(Overlay)
Vue.use(Icon)
Vue.use(Lazyload);
Vue.use(ImagePreview)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Rate);
Vue.use(Dialog);
//引入枚举类
import enums from "./libs/enums"

Vue.prototype.$enums = enums


// 引入瀑布流插件
import {VueMasonryPlugin} from 'vue-masonry';

Vue.use(VueMasonryPlugin)


//引入工具类
import util from './libs/util';

Vue.prototype.$util = util;

import VueCookies from 'vue-cookies';

Vue.use(VueCookies);
Vue.$cookies.config("12h");

//引入复制的控件
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

// 全局注册图片组件
// import vImage from "@/components/v_image"
// Vue.component("v-image", vImage)

//引入全局的vuex
import Vuex from "vuex"

Vue.use(Vuex);
import storeObj from "./store"

const store = new Vuex.Store(storeObj)
store.state.config = AppConfig; //语音聊天室

//引入i18n
import VueI18n from 'vue-i18n'
import VueI18nFilter from 'vue-i18n-filter'
import i18nDictionary from "@/i18n"

Vue.locale = () => {
};

Vue.use(VueI18nFilter)
Vue.use(VueI18n)

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
});
const i18n = new VueI18n({
  locale: store.getters.get_lang, // set locale
  messages: i18nDictionary, // set locale messages
})


//引入全局filter
import filters from "./libs/filters"

Object.keys(filters).forEach(o => Vue.filter(o, filters[o]));


import TagList from '@/components/tagList'

Vue.component(TagList.name, TagList)

import litterHelper from "@/components/litter_helper"

Vue.component(litterHelper.name, litterHelper)

// import customWrap from "@/components/custom_wrap"
// Vue.component(customWrap.name, customWrap)

// 全局注册图片组件
import vImage from "@/components/v_image"

Vue.component("v-image", vImage)

// 引入高亮组件
import TextHighlight from 'vue-text-highlight';

Vue.component('text-highlight', TextHighlight);

import preview_image from "@/components/preview_image"

Vue.component("preview-image", preview_image)

// 引入自定义滚动条组件
import customScroll from "@/components/custom_scroll"

Vue.component("custom-scroll", customScroll)

// 图片预览组件 https://github.com/heyongsheng/hevue-img-preview
import hevueImgPreview from '@/components/hevue-img-preview'

Vue.use(hevueImgPreview)

// 自定义水印插件
import watermarkPlugin from "@/components/custom_watermark/watermark.js"

Vue.use(watermarkPlugin)
/* eslint-disable no-new */
window.hv = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {App},
  template: '<App/>'
})
export default hv



// WEBPACK FOOTER //
// ./src/main.js